import { render, staticRenderFns } from "./QueryTableProductos.vue?vue&type=template&id=0f38d7a8&"
import script from "./QueryTableProductos.vue?vue&type=script&lang=js&"
export * from "./QueryTableProductos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports